import { Box } from '@mui/material'
import Button from '@mui/material/Button'
import CardActions from '@mui/material/CardActions'
import CardContent from '@mui/material/CardContent'
import React from 'react'

import SelectMultiple from '@/app/component/atom/form/select-multiple'
import { useAddToGroup } from '@/app/module/groups/hooks/use-add-to-group'

import { ContactsTableFilter } from '../../contacts/component/list/table/contacts-table'
import { useGetGroupOptions } from '../hooks/use-get-group-options'

type Props = {
  contactIds: string[]
  excludeIds: string[]
  isAllContacts: boolean
  includedGroupIds: string[]
  search: string
  groupIds: string[]
  totalRecipients: number
  recipients: { label: string; value: string }[]
  activeFilter?: ContactsTableFilter

  closeHandler: () => void
  onAddToGroupSuccess: () => void
}

const AddToGroup: React.FC<Props> = ({
  activeFilter,
  contactIds,
  excludeIds,
  isAllContacts,
  includedGroupIds,
  search,
  totalRecipients,
  recipients,
  closeHandler,
  onAddToGroupSuccess,
}) => {
  const [addToGroup, { isLoading: isAdding }] = useAddToGroup()
  const [groupIds, setGroupIds] = React.useState<string[]>([])

  const { data: groups } = useGetGroupOptions({
    page: 1,
  })

  React.useEffect(() => {
    if (activeFilter?.name === 'groups') {
      setGroupIds([activeFilter.value])
    }
  }, [activeFilter])

  const recipientsDisplay = [
    {
      label: `${totalRecipients} selected contact${totalRecipients === 1 ? '' : 's'}`,
      value: 'more',
    },
  ]

  const addToGroupHandler = async () => {
    const success = await addToGroup({
      groupIds,
      isAllContacts,
      contactIds,
      excludeIds,
      includedGroupIds,
      search,
    })
    if (success) {
      closeHandler()
      onAddToGroupSuccess()
    }
  }

  const selectMultipleGroupsHandler = ({ value }: { value: string[] }) => {
    setGroupIds(value)
  }

  return (
    <form
      id="add-to-form"
      onSubmit={(e) => {
        e.preventDefault()
        if (!isAdding || totalRecipients) {
          addToGroupHandler()
        }
      }}
    >
      <CardContent>
        <SelectMultiple
          id="add-to-group-contacts"
          disabled
          label="Add"
          name="contacts"
          value={recipientsDisplay.map(({ value }) => value)}
          values={recipientsDisplay}
          message={`Please select the groups you want to add the ${totalRecipients} selected contact${
            totalRecipients === 1 ? '' : 's'
          } to`}
        />
        <SelectMultiple
          id="add-to-group-groups"
          label="Group"
          name="groups"
          value={groupIds}
          values={groups}
          editable={true}
          onChange={selectMultipleGroupsHandler}
        />
      </CardContent>
      <CardActions>
        <Box display="flex" flexDirection="row" alignItems="center" justifyContent="flex-end">
          <Button
            id="add-to-group-action"
            color="primary"
            disabled={!groupIds.length || !recipients.length}
            loading={isAdding}
            type="submit"
            variant="contained"
          >
            Add To Group
          </Button>
        </Box>
      </CardActions>
    </form>
  )
}

export default AddToGroup

export type { Props as AddToGroupProps }
